import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  BooleanField,
  BooleanInput,
  DateField,
  DateInput,
  Resource,
  Show,
  Datagrid,
  EditButton,
  required,
} from "react-admin";

const DatabaseVersionList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" label="Version ID" />
      <TextField source="name" label="Name" />
      <TextField source="description" label="Description" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="releaseDate" label="Release Date" />
      <DateField source="deprecatedDate" label="Deprecation Date" />
      <EditButton />
    </Datagrid>
  </List>
);

const DatabaseVersionShow = (props) => (
  <Show {...props}>
    <SimpleForm>
      <TextField source="id" label="Version ID" />
      <TextField source="name" label="Name" />
      <TextField source="description" label="Description" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="releaseDate" label="Release Date" />
      <DateField source="deprecatedDate" label="Deprecation Date" />
    </SimpleForm>
  </Show>
);

const DatabaseVersionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" validate={required()} />
      <TextInput source="description" label="Description" multiline fullWidth />
      <BooleanInput source="isActive" label="Active" />
      <DateInput source="releaseDate" label="Release Date" />
      <DateInput source="deprecatedDate" label="Deprecation Date" />
    </SimpleForm>
  </Create>
);

const DatabaseVersionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="id" label="Version ID" />
      <TextInput source="name" label="Name" validate={required()} />
      <TextInput source="description" label="Description" multiline fullWidth />
      <BooleanInput source="isActive" label="Active" />
      <DateInput source="releaseDate" label="Release Date" />
      <DateInput source="deprecatedDate" label="Deprecation Date" />
    </SimpleForm>
  </Edit>
);

const databaseVersionResource = () => (
  <Resource
    name="databaseVersion"
    options={{ label: "DB Versions", menuGroup: "Bcome" }}
    list={DatabaseVersionList}
    show={DatabaseVersionShow}
    create={DatabaseVersionCreate}
    edit={DatabaseVersionEdit}
  />
);

export default databaseVersionResource;
